import React, { useEffect, useState } from 'react';
import './setting.css';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import Sidebox from './SideBox';
import ApiService from '../../../services/apiService';
import { setTaxExplicit, setTaxImplicit } from '../../../../Redux/actions/taxActions';
import { getTaxExplicit, getTaxImplicit } from '../../../../Redux/selecters';

const TaxSetting = () => {
  const dispatch = useDispatch();

  const taxExplicit = useSelector(getTaxExplicit);
  const taxImplicit = useSelector(getTaxImplicit);

  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  const syncReduxWithApiValue = (taxInclusive) => {
    if (taxInclusive) {
      dispatch(setTaxImplicit(true));
      dispatch(setTaxExplicit(false));
    } else {
      dispatch(setTaxExplicit(true));
      dispatch(setTaxImplicit(false));
    }
  };

  const fetchTaxSetting = async () => {
    try {
      setInitialLoading(true);
      const apiService = new ApiService();
      const res = await apiService.get('GET_TAX_SETTING');

      const taxInclusive = Boolean(res?.data?.result?.taxInclusive);
      syncReduxWithApiValue(taxInclusive);
    } catch (error) {
      console.error('Failed to fetch tax setting:', error);
      toast.error('Failed to load tax setting');
    } finally {
      setInitialLoading(false);
    }
  };

  const updateTaxSetting = async (taxInclusive) => {
    try {
      setLoading(true);

      const apiService = new ApiService();
      const body = {
        taxInclusive,
      };

      const res = await apiService.put('UPDATE_TAX_SETTING', body);

      if (res?.data?.statusCode === 200 || res?.data?.statusCode === 201) {
        syncReduxWithApiValue(taxInclusive);
        toast.success(res?.data?.message || 'Tax setting updated successfully');
      } else {
        toast.warning(res?.data?.message || 'Failed to update tax setting');
      }
    } catch (error) {
      console.error('Failed to update tax setting:', error);
      toast.error('Failed to update tax setting');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTaxSetting();
  }, []);

  const handleTaxExplicitChange = () => {
    if (loading || initialLoading) return;
    updateTaxSetting(false);
  };

  const handleTaxImplicitChange = () => {
    if (loading || initialLoading) return;
    updateTaxSetting(true);
  };

  return (
    <div className="container">
      <div className="pading-space pt-5">
        <div className="pt-5 pb-4">
          <div className="row">
            <div className="col-3 pt-5">
              <Sidebox />
            </div>

            <div className="col-9 px-5">
              <div className="pb-5">
                <span className="settingtext">Tax Explicit/Implicit</span>
              </div>

              {(initialLoading || loading) && (
                <div className="pb-3">
                  <span className="notificationtxt">{initialLoading ? 'Loading tax setting...' : 'Saving tax setting...'}</span>
                </div>
              )}

              <div className="row">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="taxExplicitCheck"
                    checked={taxExplicit}
                    onChange={handleTaxExplicitChange}
                    disabled={loading || initialLoading}
                  />
                  <label className="form-check-label" htmlFor="taxExplicitCheck">
                    <h5 className="notificationhead">Tax Explicit</h5>
                  </label>
                  <div>
                    <span className="notificationtxt">Enable explicit tax calculation.</span>
                  </div>
                </div>

                <div className="form-check pt-4">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="taxImplicitCheck"
                    checked={taxImplicit}
                    onChange={handleTaxImplicitChange}
                    disabled={loading || initialLoading}
                  />
                  <label className="form-check-label" htmlFor="taxImplicitCheck">
                    <h5 className="notificationhead">Tax Implicit</h5>
                  </label>
                  <div>
                    <span className="notificationtxt">Enable implicit tax calculation.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxSetting;
